import { customRef } from "vue";

const VALID_SORT_VALUES = [null, "asc", "desc"];

export const useTableSort = (
  availableSorts = ["default"],
  defaultSort = { type: "default", value: "asc" },
) => {
  const sort = customRef((track, trigger) => {
    let type = defaultSort.type;
    let value = defaultSort.value;
    return {
      get() {
        track();
        return { type, value, string: value ? `${type},${value}` : "" };
      },
      set(v) {
        let newType;
        let newValue;
        if (typeof v === "string") [newType, newValue] = v.split(",");
        else if (Array.isArray(v)) [newType, newValue] = v;
        else if (typeof v === "object") ({ type: newType, value: newValue } = v);
        else ({ type: newType, value: newValue } = defaultSort);

        if (!availableSorts.includes(newType) || !VALID_SORT_VALUES.includes(newValue)) {
          ({ type: newType, value: newValue } = defaultSort);
        }

        type = newType;
        value = newValue;
        trigger();
      },
    };
  });

  return sort;
};
